import { Component, OnInit } from '@angular/core';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterOutlet, MatSnackBarModule],
})
export class AppComponent implements OnInit {
    /**
     * Constructor
     */
    constructor(
    ) {
    }

    ngOnInit(): void {
       
    }

}
